module.exports = __webpack_public_path__ + "img/arte.51d8eecb.png";